interface InsightCardProps {
  title: string;
  value: string;
  subtitle: string;
  tone?: 'light' | 'night';
}

const InsightCard = ({ title, value, subtitle, tone = 'light' }: InsightCardProps) => {
  const trendFill = `${56 + ((title.length * 11) % 35)}%`;
  const classNameByTone =
    tone === 'night'
      ? {
          shell: 'border-slate-700/70 bg-[#111b2f] text-white',
          title: 'text-slate-300',
          subtitle: 'text-slate-400',
          badge: 'bg-orange-500/20 text-orange-200',
          progressBg: 'bg-slate-800',
          progressBar: 'bg-orange-400',
        }
      : {
          shell: 'border-slate-200/80 bg-white text-slate-900',
          title: 'text-slate-500',
          subtitle: 'text-slate-500',
          badge: 'bg-orange-50 text-orange-700',
          progressBg: 'bg-slate-100',
          progressBar: 'bg-orange-500',
        };

  return (
    <article className={`rounded-2xl border p-4 shadow-[0_14px_30px_-24px_rgba(15,23,42,0.48)] ${classNameByTone.shell}`}>
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className={`text-xs font-semibold uppercase tracking-wide ${classNameByTone.title}`}>{title}</p>
          <p className="mt-2 text-3xl font-semibold leading-none">{value}</p>
          <p className={`mt-2 text-xs ${classNameByTone.subtitle}`}>{subtitle}</p>
        </div>
        <span className={`inline-flex h-10 w-10 items-center justify-center rounded-xl text-sm font-semibold ${classNameByTone.badge}`}>
          {title.charAt(0).toUpperCase()}
        </span>
      </div>
      <div className={`mt-3 h-1.5 rounded-full ${classNameByTone.progressBg}`}>
        <div className={`h-1.5 rounded-full ${classNameByTone.progressBar}`} style={{ width: trendFill }} />
      </div>
    </article>
  );
};

export default InsightCard;
